import React from 'react'

interface BrushCleanerProps {
  className?: string
}

export const BrushCleaner: React.FC<BrushCleanerProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={`M10.6666 14.6663L9.99998 11.9997M12.6666 9.32634C12.8435 9.32634 13.013 9.2561 
        13.1381 9.13108C13.2631 9.00605 13.3333 8.83648 13.3333 8.65967V7.99967C13.3333 7.64605 
        13.1928 7.30691 12.9428 7.05687C12.6927 6.80682 12.3536 6.66634 12 6.66634H9.99998C9.82317 
        6.66634 9.6536 6.5961 9.52858 6.47108C9.40355 6.34605 9.33332 6.17649 9.33332 5.99967V2.66634C
        9.33332 2.31272 9.19284 1.97358 8.94279 1.72353C8.69274 1.47348 8.35361 1.33301 7.99998 
        1.33301C7.64636 1.33301 7.30722 1.47348 7.05717 1.72353C6.80713 1.97358 6.66665 2.31272 
        6.66665 2.66634V5.99967C6.66665 6.17649 6.59641 6.34605 6.47139 6.47108C6.34636 6.5961 
        6.17679 6.66634 5.99998 6.66634H3.99998C3.64636 6.66634 3.30722 6.80682 3.05717 7.05687C
        2.80713 7.30691 2.66665 7.64605 2.66665 7.99967V8.65967C2.66665 8.83648 2.73689 9.00605 
        2.86191 9.13108C2.98694 9.2561 3.15651 9.32634 3.33332 9.32634M5.33332 14.6663L5.99998 
        11.9997M3.33332 9.33301H12.6666L13.982 13.8443C14.0055 13.9424 14.0064 14.0444 13.9848 
        14.1429C13.9631 14.2413 13.9194 14.3335 13.857 14.4127C13.7946 14.4918 13.715 14.5557 
        13.6243 14.5997C13.5336 14.6436 13.4341 14.6664 13.3333 14.6663H2.66665C2.56586 14.6664 
        2.46637 14.6436 2.37567 14.5997C2.28496 14.5557 2.20539 14.4918 2.14296 14.4127C2.08052 
        14.3335 2.03684 14.2413 2.01519 14.1429C1.99354 14.0444 1.9945 13.9424 2.01798 13.8443L
        3.33332 9.33301Z`}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33"
      />
    </svg>
  )
}
